'use client'

import { Box, Container, Typography, Chip } from '@mui/material';
import Content from '@/components/ui/specified-commercial-transaction/content';
import { useTranslations } from 'next-intl';

export default function SCTcontent() {
    const t = useTranslations('SctPage.SCTcontent');

    const ACCENT = '#F15859';

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f8fafc' }}>
            {/* Header */}
            <Box sx={{ backgroundColor: '#132c4b', color: 'white', py: { xs: 8, md: 8 }, mb: { xs: 8, md: 10 } }}>
                <Container maxWidth="lg">
                    <Chip
                        label={t('chip')}
                        sx={{
                            bgcolor: ACCENT,
                            color: "white",
                            fontWeight: 700,
                            mb: 3,
                        }}
                    />
                    <Typography
                        component="h1"
                        sx={{
                            fontSize: { xs: "24px", md: "36px" },
                            fontWeight: 800,
                            lineHeight: 1.1,
                            mb: 2,
                        }}
                    >
                        {t('title')}
                    </Typography>
                    <Typography
                        sx={{
                            color: "rgba(255,255,255)",
                            mb: 2,
                            maxWidth: "80%",
                            fontSize: "14px",
                        }}
                    >
                        {t('description')}
                    </Typography>
                </Container>
            </Box>

            <Container maxWidth="lg">
                <Content />
            </Container>
        </Box>
    );
}
